import { contextFactory } from '@frontend/design-system';
import { UseFormsBuilderProviderInitResults } from './hooks';

/**
 * This context is used to provide the form builder with the props passed in.
 * Especially useful for the form builder to know which form to load.
 */
export const [FormBuilderContext, useFormBuilderContext] = contextFactory<UseFormsBuilderProviderInitResults>();
